import React, { useState } from 'react';
import { faStar as faStarSolid } from '@fortawesome/free-solid-svg-icons';
import { faStar as faStarRegular } from '@fortawesome/free-regular-svg-icons';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconPrefix } from '@fortawesome/fontawesome-svg-core';
import styled from 'styled-components';

const Icon = styled(FontAwesomeIcon)`
  color: #6c757d;
  :hover {
    color: #000000;
  }
`;

interface StarInputProps {
  onClick?: () => void;
  selected?: boolean;
}

export const StarInput: React.FC<StarInputProps> = (props) => {
  const { onClick, selected } = props;

  if (selected) {
    return (
      <Button variant="link" disabled>
        <FontAwesomeIcon
          icon={faStarSolid}
          fixedWidth
          color={'yellow'}
          style={{ stroke: 'black', strokeWidth: '15' }}
        />
      </Button>
    );
  }
  return (
    <Button variant="link" onClick={() => onClick && onClick()}>
      <Icon fixedWidth icon={faStarRegular} />
    </Button>
  );
};
